import { render, staticRenderFns } from "./SMS.vue?vue&type=template&id=564c64c9"
import script from "./SMS.vue?vue&type=script&lang=js"
export * from "./SMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports